// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"794":"cca4fc10","930":"36bcfd8d","947":"c83cf65b"}[chunkId] + ".chunk.js";
};